import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {HttpService} from './http.service';
import {UtilService} from './util.service';

@Injectable()
export class HcaUserManagementService {
  constructor(private http: HttpService, private utilService: UtilService) {
  }

  showHcaAdmins() {
    return this.http.get(`/getAllAdminsAddedByHotelChainAdmin`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  changeHcaUserStatus(hcaId, status) {
    return this.http.get(`/updateHcaAdminsStatus/${hcaId}/${status}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getHcaInfo(id) {
    return this.http.get(`/getHcaAdminData/${id}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getRolesForHCA() {
    return this.http.get(`/getRolesToAddByHCA`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getHotelBrandsByHotelChain() {
    const hotelChainId = JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId;
    return this.http.get(`/getHotelBrands/${hotelChainId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getHotelsByBrand(brandId) {
    return this.http.post(`/getAllBrandHotels`, brandId)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  saveHcaAdmin(user) {
    return this.http.post(`/AddNewHcaAdmin`, user)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  updateHcaAdmin(user) {
    return this.http.post(`/updateAdminAccount`, user)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/_services/hca-user-management.service.ts